import BaseStep from "../../../../../../../shared/wizard/steps/baseStep";
import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import { IFillDataWizardSell } from "../../..";
import Button from "../../../../../../../ui/button";
import AuthModal from "../../../../../../auth/components/modals/authModal";
import { useNavigate } from "react-router-dom";
import useDealRequestExchange, {
  EDealRequestLinkType,
} from "../../../../../../../../api/hooks/use-deal-request-exchange";
import { getAccessToken } from "../../../../../../../../lib/services/localStorage.service";
import { toast } from "react-toastify";
import { PATHS } from "../../../../../../../shared/constants";
import useOpenModal from "../../../../../../../ui/modal/hooks/useOpenModal";

interface IDoNotKnowPriceSwapStep_6 {
  data: IFillDataWizardSell;
}

const DoNotKnowPriceSwapStep_6 = ({ data }: IDoNotKnowPriceSwapStep_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_5);
  };

  const navigate = useNavigate();

  const { error, isMutating, trigger } = useDealRequestExchange();

  const { offsetY, open, handleChangeModal } = useOpenModal();

  const handleSendData = async () => {
    if (getAccessToken()) {
      try {
        await trigger({ type: EDealRequestLinkType.Swap, data });
        toast.success("Заявка на обмен создана");
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error?.message === "Unauthorized") {
          handleChangeModal(true);
        }
        toast.error("Ошибка не удалось отправить заявку");
      }
    } else {
      handleChangeModal(true);
    }
  };

  return (
    <div>
      <BaseStep prevStep={handlePrevStep} text="Отправка заявки:">
        <div>
          <Button
            label="Отправить заявку на покупку"
            onClick={handleSendData}
          />
          <AuthModal
            opened={open}
            onClose={() => handleChangeModal(false)}
            offsetY={offsetY}
          />
        </div>
      </BaseStep>
    </div>
  );
};

export default DoNotKnowPriceSwapStep_6;
